// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2662":"1112d5966e698430","6100":"a57eca283f69d3a7"}[chunkId] + ".css";
};